import { useEditor } from "@craftjs/core";
import { useLayer } from "@craftjs/layers";
import { Typography } from "@mui/material";

const LayerName = () => {
    const { id } = useLayer();
    const { displayName } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
        hidden: state.nodes[id] && state.nodes[id].data.hidden,
    }));

    return <Typography variant="caption">{displayName}</Typography>;
};

export default LayerName;
